import {AfterViewInit, Component, OnInit} from '@angular/core';
import {TemporalPasswordService} from "../../lib/services/temporal-password/temporal-password.service";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {ModalsService} from "../../lib/services/modals/modals.service";
import {LoadingService} from "../../lib/services/loading/loading.service";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {Router} from "@angular/router";
import jwt_decode from "jwt-decode";
import {ContractService} from "../../lib/services/contracts/contract.service";
import {TokenExpiredTimerService} from "../../lib/services/token-expired-timer/token-expired-timer.service";
import * as pubsub from "pubsub-js"

@Component({
    selector: 'app-change-temporal-password',
    templateUrl: './change-temporal-password.component.html',
    styleUrls: ['./change-temporal-password.component.scss']
})
export class ChangeTemporalPasswordComponent implements OnInit {

    cveUsuario = ''
    showModalResponseModal = false;
    showError = false;
    errorCode;
    loading = false;
    showProgressSpinner = false;

    constructor(private temporalPasswordService: TemporalPasswordService,
                private userUtils: UserUtilsService,
                private modalService: ModalsService,
                private loadingService: LoadingService,
                private router: Router,
                private contractService: ContractService,
                private tokenExpiredTimerService: TokenExpiredTimerService) {
        this.cveUsuario = userUtils.getCveUser()
    }

    ngOnInit() {
        pubsub.subscribe("PROGRESS_SPINNER", (msg: any, data: any) => {
            this.showProgressSpinner = data
        })
    }

    changePassword(event) {
        this.loadingService.show();
        this.showError = false;
        this.temporalPasswordService.changeTemporalPassword({
            currentPassword: event.currentPassword,
            newPassword: event.password
        }).subscribe({
            next: (response: any) => {
                if (response?.code != "1") {
                    this.getErrorCode(response?.code);
                    this.showError = true;
                    this.showModalResponseModal = true;
                    return;
                } else {
                    this.updateJwtStorage(response?.authorizationBanca)
                    this.getContracts()
                }
            },
            error: () => {
                this.showError = true;
                this.showModalResponseModal = true;
                this.errorCode = 'unknown';
                this.loadingService.hide()
            },
            complete: () => {
                this.loadingService.hide()
            }
        })
    }

    closeModalResponseModal() {
        this.showModalResponseModal = false;
        if (!this.showError) {
            this.router.navigate(['/nueva-banca-digital/dashboard'])
        }
    }

    getErrorCode(code) {
        switch (code) {
            case -1:
                this.errorCode = "invalidUserCode";
                return;
            case -3:
                this.errorCode = "newPasswordError"
                return;
            case -4:
                this.errorCode = "currenPasswordError"
                return
            default:
                this.errorCode = 'unknown';
        }
    }

    getErrorMessage() {
        return !this.showError ? 'temporaryPassword.changePasswordSuccessBody' : `temporaryPassword.error.${this.errorCode}`;
    }

    private updateJwtStorage(token) {
        sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN_WSO, token);
    }

    getContracts() {
        const tokenString: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const token: any = jwt_decode(tokenString)
        this.contractService.getContractInformationByUser().subscribe({
            next: async contracts => {
                const contractInformationString = sessionStorage.getItem(StorageKeysEnum.CONTRACTS_INFORMATION)
                const contractInformation: any = contractInformationString ? JSON.parse(contractInformationString) : {};
                sessionStorage.setItem(StorageKeysEnum.CONTRACTS_INFORMATION, JSON.stringify({
                    ...contractInformation,
                    contractsUser: contracts.datos.isrvContrato.contratos
                }));
                this.userUtils.setUserInfoSessionStorage(
                    {
                        name: token.usuario,
                        fullName: contracts?.datos?.nomCompleto,
                        typePerson: contracts?.datos?.cvePersJuridica,
                        contrato: contracts?.datos?.isrvContrato.contratos
                    }
                )
                this.tokenExpiredTimerService.startLogoutTimer();
                this.showModalResponseModal = true;
            },
            error: error => {
                this.getErrorCode(null)
                this.getErrorMessage();
                this.showModalResponseModal = true;
            }
        })
    }
}
